!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("@material-ui/core"), require("@material-ui/styles")) : "function" == typeof define && define.amd ? define(["exports", "react", "@material-ui/core", "@material-ui/styles"], t) : t((e = e || self).cake = {}, e.React, e.core, e.styles);
}(this, function (e, t, r, n) {
  "use strict";

  t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;

  var _a = function a() {
    return (_a = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);

      return e;
    }).apply(this, arguments);
  },
      i = n.makeStyles(function () {
    return n.createStyles({
      card: {
        border: "1px solid #e9e9e9"
      }
    });
  });

  e.Cake = function (e) {
    var n = e.children,
        c = e.cardProps;
    return t.createElement(r.Card, _a({}, c, {
      elevation: 0,
      className: i().card
    }), n);
  }, e.CakeActions = function (e) {
    var n = e.cardActionProps,
        i = e.children;
    return t.createElement(r.CardActions, _a({}, n), i);
  }, e.CakeContent = function (e) {
    var n = e.children,
        i = e.cardContentProps,
        c = e.style;
    return t.createElement(r.CardContent, _a({}, i, {
      style: _a({}, c)
    }), n);
  }, e.CakeHeader = function (e) {
    var n = e.style,
        i = e.heading,
        c = e.description,
        o = e.actions;
    return t.createElement(r.Grid, {
      container: !0,
      style: _a({
        padding: 16
      }, n)
    }, t.createElement(r.Grid, {
      item: !0,
      container: !0,
      direction: "column",
      xs: !0
    }, t.createElement(r.Grid, {
      item: !0,
      xs: !0,
      style: {
        marginBottom: 8
      }
    }, t.createElement(r.Typography, {
      variant: "h5",
      display: "inline",
      style: {
        fontWeight: "bold"
      }
    }, i)), t.createElement(r.Grid, {
      item: !0,
      xs: !0
    }, c)), t.createElement(r.Grid, {
      item: !0,
      style: {
        width: "70px",
        height: "70px"
      }
    }, o));
  }, e.CakeImage = function (e) {
    var r = e.src,
        n = e.alt;
    return t.createElement("img", {
      src: r,
      width: "100%",
      height: "100%",
      alt: n
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});